module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_yxx-e6f272484a66c55c8927e614269d8dcd.png";